<template>
  <div v-if="shareinfo.cuid">
    <div class="saas-header" v-if="saasable">
        <img :src="largelinklogo" />
    </div>
    <div class="saas-bottom" id="saas-bottom" v-if="saasable">
      <!-- <div class="saas-bottom-box"> -->
        <img src="/kabala/images/logo/saas/ad_bottom.png" class="saas-ad-bg"/>
        <img src="/kabala/images/logo/saas/ad_qrcode.jpg" class="pabs saas-ad-qrcode"/>
        <a href="javascript:;" class="saas-btn-close pabs" onclick="closeAdBottom()"></a>
        <a href="https://www.kasscloud.com/" class="saas-btn-home pabs"></a>
        <a href="https://www.kasscloud.com/kassweb/pages/resource.html" class="pabs saas-btn-resource"></a>
      <!-- </div> -->
    </div>
    <div class="header">
      <div>
        <!-- <kabala-userheader shape="circle" :user="shareinfo.cuid" /> -->
      </div>
      <div class="thumb-body ft16">
        <div class="ft16">{{ shareinfo.cname }}</div>
        <div class="ft14">{{ shareinfo.ctime_f }}</div>
      </div>
    </div>
    <div class="body">
      <div>
        <span>失效时间</span>
        <span>{{ shareinfo.expiretime_f }}</span>
      </div>
      <div>
        <span>分享权限</span>
        <span>{{ operationsStr }}</span>
      </div>
      <div v-if="shareinfo.comments">
        <span>分享备注</span>
        <span>{{ shareinfo.comments }}</span>
      </div>
    </div>
    <div id="ad-banner" class="saas-ad-banner" v-if="saasable">
        <div style="position:relative; display: inline-block;padding:5px 0 0;" onclick="showTrial()">
            <i onclick="closeAd()"></i>
            <img src="/kabala/images/logo/saas/ad_banner.png" alt="" >
        </div>
    </div>
    <div style="width: 100%; height: 10px; background: #f2f2f2;"></div>
    <div class="footer">
      <p class="fileLen router ft16" v-show="showPaths.length>0">
        <a
          v-for="(path, idx) in showPaths"
          :key="idx"
          @click="onRouterClick(path, idx)"
        >/ {{ path.name }}</a>
      </p>
      <div>
        <p class="fileLen">共 {{ fileList.length }} 个文件</p>
      </div>
      <div v-if="fileList.length > 0" class="file-list-box">
        <!-- <van-pull-refresh v-model="refreshing" @refresh="onRefresh" style="width: 100%"> -->
          <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
            <van-checkbox-group v-model="selectNodes" ref="checkboxGroup">
              <van-cell-group>
                <van-cell
                  class="list-item"
                  v-for="(item, index) in fileList"
                  clickable
                  :key="item.node.cnum"
                  ref="filecell"
                >
                  <template #title>
                    <div @click="onNodeClick(index, item)" class="list-item-fileicon">
                      <kabala-fileicon
                        :node="item.node"
                        size="11.333333vw"
                        :moreinfo="true"
                        class="fileicon"
                      />
                    </div>
                  </template>
                  <template #right-icon>
                    <van-checkbox
                      class="file-btn"
                      :name="item.node"
                      ref="checkbox"
                      @click="onCheckboxClick(index)"
                    />
                  </template>
                </van-cell>
              </van-cell-group>
            </van-checkbox-group>
          </van-list>
        <!-- </van-pull-refresh> -->
      </div>
    </div>
    <!-- 功能按钮 -->
    <van-action-sheet class="btngroup" v-model="showBtn" :overlay="false" :lock-scroll="false">
      <van-grid :column-num="5" :border="false" clickable class="vau">
        <!--链接分享-->
        <!-- <van-grid-item
          v-if="canShareLink"
          icon-prefix="k"
          icon="link"
          :text="$t('pan.button.linkShare')"
          id="link"
          style="font-size: 16px; border: none"
          @click="openLinkShare"
        />-->
        <!--同事分享-->
        <!-- <van-grid-item
          v-if="canShareUser"
          icon-prefix="k"
          icon="colleague"
          :text="$t('pan.button.teamShare')"
          id="share"
          style="font-size: 16px; border: none"
          @click="openUserShare"
        />-->

        <!--编辑-->
        <van-grid-item
          icon-prefix="k"
          icon="editor"
          href="#"
          v-if="canOnlineEdit"
          :text="$t('pan.button.onlineEdit')"
          id="edit"
          style="border: none"
          @click="onEdit(false)"
        />
        <!-- 共享编辑 -->
        <van-grid-item
          icon-prefix="k"
          icon="editor"
          href="#"
          v-if="canShareEdit"
          :text="$t('pan.button.wpsedit')"
          id="edit"
          style="border: none"
          @click="onEdit(true)"
        />
        <!--查看详情-->
        <van-grid-item
          v-if="canViewDetail"
          style="border: none"
          icon-prefix="k"
          icon="detail"
          :text="$t('pan.button.viewDetail')"
          id="detail"
          @click="onDetail"
        />
        <!--下载-->
        <van-grid-item
          v-if="canDownload"
          icon-prefix="k"
          icon="download"
          :text="$t('pan.button.download')"
          @click="onDownLoad"
        />
        <!-- 重命名
        <van-grid-item
          v-if="canRename"
          icon-prefix="k"
          icon="rename"
          :text="$t('pan.button.rename')"
          id="rename"
          style="border: none"
          @click="onRename"
        />-->
      </van-grid>
    </van-action-sheet>

    <!-- 在线编辑 预览url -->
    <van-popup
      v-model="showUrlBox"
      get-container="#app"
      duration="0.1"
      style="width: 100%; height: 100%"
    >
      <div style="width: 100%; height: calc(100% - 55px);">
        <div
          @click="closeUrlPop"
          style="
            height: 55px;
            line-height: 55px;
            padding-left: 16px;
            font-size: 4.266667vw;
            font-weight: bold;
          "
        >
          <i
            class="van-icon van-icon-arrow-left van-nav-bar__arrow"
            style="position: relative; top: 2px"
          ></i>
          {{ urlTitle }}
        </div>
        <div
          style="
            box-sizing: border-box;
            background: #fff;
            position: relative;
            height: 100%;
          "
        >
          <iframe :src="url" style="width: 100%; height: 100%; border: none"></iframe>
        </div>
      </div>
    </van-popup>

    <!--    文件详情-->
    <van-popup
      v-model="showDetail"
      get-container="#app"
      duration="0.1"
      style="width: 100%; height: 100%"
    >
      <file-detail :path="detailPath" :canReturn="true" :callback="returnFromDetail"></file-detail>
    </van-popup>


<!-- 获取验证码 -->
    <div v-if="saasable" id="mask" style="display:none;"></div>
    <div v-if="saasable" id="Dialog_Main_Phone" style="display:none;position:fixed; z-index:999;top:15%;left:50%;transform: translateX(-50%);background-color: #ffffff; width:420px; max-width: 90%;min-height:360px; border-radius: 3px;box-shadow: 0 0 14px #333;">
        <span class="btn_close" onclick="hideTrial()">+</span>
        <p class="fs16 desc" style="font-size: 16px;">填写信息以获取资料</p>
        <p class="fs14 desc" style="font-size: 14px;">为了能更好地服务您，请您填写以下信息，如遇问题，请您拨打免费服务热线：<span>400-889-1088</span> 或点击 <span>在线咨询</span>。</p>
        <div class="userinfo">
            <p class="fs14" style="font-size: 14px;"><b style="color: #ff6803;">*</b> 手机号</p>
            <p><input type="text" id="resphone" style="color:#333;border:1px solid #ccc;width:100%;height:40px;line-height:30px; border-radius: 5px 5px 5px 5px; padding-left:10px; font-size:14px; outline-color:#469fe3;" placeholder="请输入您的手机号码" value="" /></p>
            <p class="fs14" style="font-size: 14px;"><b style="color: #ff6803;">*</b> 验证码</p>
            <p style="overflow:hidden;"><input type="text" id="rescode" style="color:#333;border:1px solid #ccc;width:70%;height:40px;line-height:30px; border-radius: 5px 5px 5px 5px; padding-left:10px; font-size:14px; outline-color:#469fe3;" placeholder="请输入验证码" value="" /><button id="btn_sendphone" class="btn blue" onclick="sendPhone()">获取验证码</button></p>
            <p class="btn blue" style="font-size: 14px;" onclick="sendPhoneNext()">下一步</p>
            <p class="btn grey" style="font-size: 14px;" onclick="javascript:window.open('http://chat8.live800.com/live800/chatClient/chatbox.jsp?companyID=63537&configID=53688&jid=8492420137 ')">在线咨询</p>
        </div>
    </div>
    <!-- 填写个人信息 -->
    <div v-if="saasable" id="Dialog_Main_UserInfo">
        <!-- <span class="btn_close" onClick="closePhone('userinfo')">+</span> -->
        <p class="fs16 desc" style="font-size: 16px;">建议提供更多信息享受VIP客服</p>
        <div class="userinfo">
            <p class="fs14" style="font-size: 14px;">您的称呼：</p>
            <p><input type="text" id="user_name" style="color:#333;border:1px solid #ccc;width:100%;height:40px;line-height:30px; border-radius: 5px 5px 5px 5px; padding-left:10px; font-size:14px; outline-color:#469fe3;" placeholder="请输入您的称呼" value="" /></p>
            <p class="fs14" style="font-size: 14px;">公司所处行业：</p>
            <p><input type="text" id="user_trade" style="color:#333;border:1px solid #ccc;width:100%;height:40px;line-height:30px; border-radius: 5px 5px 5px 5px; padding-left:10px; font-size:14px; outline-color:#469fe3;" placeholder="请输入您的公司所处行业" value="" /></p>
            <p class="fs14" style="font-size: 14px;">想了解的产品：</p>
            <p>
                <select id="res_app" style="color:#333;border:1px solid #ccc;width:100%;height:40px;line-height:30px; border-radius: 5px 5px 5px 5px; padding-left:10px; font-size:14px; outline-color:#469fe3;" placeholder="请选择想了解的产品">
                    <option value="">请选择想了解的产品</option>
                    <option value="企业网盘">企业网盘</option>
                    <option value="档案管理">档案管理</option>
                    <option value="体系文件管理">体系文件管理</option>
                    <option value="产品信息管理">产品信息管理</option>
                    <option value="文件中间件">文件中间件</option>
                    <option value="文件业务平台">文件业务平台</option>
                    <option value="文件桌面套件">文件桌面套件</option>
                    <option value="Kass文档管理">Kass文档管理</option>
                </select>
            </p>
            <p class="fs14" style="font-size: 14px;">接待类型：</p>
            <p>
                <select id="res_usrtype" style="color:#333;border:1px solid #ccc;width:100%;height:40px;line-height:30px; border-radius: 5px 5px 5px 5px; padding-left:10px; font-size:14px; outline-color:#469fe3;" placeholder="请选择接待类型">
                    <option value="">请选择接待类型</option>
                    <option value="销售经理">销售经理</option>
                    <option value="大客户经理">大客户经理</option>
                    <option value="渠道经理">渠道经理</option>
                </select>
            </p>
            <p class="fs14" style="font-size: 14px;">需求备注：</p>
            <p><input type="text" id="user_comment" style="color:#333;border:1px solid #ccc;width:100%;height:40px;line-height:30px; border-radius: 5px 5px 5px 5px; padding-left:10px; font-size:14px; outline-color:#469fe3;" placeholder="请简约描述下您的需求" value="" /></p>
            <p class="btn blue" style="font-size: 14px;" onclick="sendUserInfo(true)">提交</p>
            <p class="btn grey" style="font-size: 14px;" onclick="sendUserInfo(false)">忽略</p>
            <p class="btn grey" style="font-size: 14px;" onclick="javascript:window.open('http://chat8.live800.com/live800/chatClient/chatbox.jsp?companyID=63537&configID=53688&jid=8492420137 ')">在线咨询</p>
        </div>
    </div>
    <div class="backtotop" @click.stop="onBackToTop" v-show="showGoToTop">
      <van-icon name="arrow-up" />
    </div>
    
  </div>
</template>

<script>
import { Toast } from "vant";
import kabalaUserheader from "@/components/common/kabala-userheader";
import KabalaFileicon from "@/components/common/kabala-fileicon";
import FileDetail from "@/pages/detail/FileDetail";
export default {
  name: "ShareDetail",
  components: {
    FileDetail,
    kabalaUserheader,
    KabalaFileicon,
  },
  data() {
    return {
      showGoToTop: false,
      shareid: "",
      shareinfo: {},
      fileList: [],
      refreshing: false,
      loading: false,
      finished: true,
      selectNodes: [],
      showUrlBox: false,
      urlTitle: "",
      url: "",
      currentPath: "",
      showRoot: true,
      showPaths: [],
      showDetail: false,
      detailPath: "",
      openApiUrl: "/api/pan/share/open",
      embedsendApiUrl: "/api/pan/share/embedsend",
      sharetype: "",
      saasable:false,
      serverInfo:{},
      largelinklogo:"",
    };
  },
  computed: {
    canShareLink() {
      return (
        this.selectNodes.length > 0 &&
        this.shareinfo.operations.indexOf("tolinks") > -1
      );
    },
    canShareUser() {
      return (
        this.selectNodes.length > 0 &&
        this.shareinfo.operations.indexOf("tousers") > -1
      );
    },
    canShareEdit() {
      let type = ['xlsx', 'xls', 'doc', 'docx', 'ppt', 'pptx'];
      return (
        this.selectNodes.length === 1 &&
        this.selectNodes[0].isfile &&
        type.indexOf(this.selectNodes[0].path?.getSuffixed(false).toLowerCase()) > -1 &&
        this.shareinfo.operations.indexOf("shareedit") > -1
      );
    },
    canOnlineEdit() {
      let type = ['xlsx', 'xls', 'doc', 'docx', 'ppt', 'pptx'];
      return (
        this.selectNodes.length === 1 &&
        this.selectNodes[0].isfile &&
        type.indexOf(this.selectNodes[0].path?.getSuffixed(false).toLowerCase()) > -1 &&
        this.shareinfo.operations.indexOf("onlineedit") > -1
      );
    },
    canViewDetail() {
      return (
        this.selectNodes.length === 1 &&
        this.shareinfo.operations.indexOf("preview") > -1 &&
        this.sharetype != 'link'
      );
    },
    canDownload() {
      return (
        this.selectNodes.length === 1 &&
        this.shareinfo.operations.indexOf("download") > -1 &&
        this.selectNodes[0].isfile
      );
    },
    // canRename() {
    //   return this.selectNodes.length === 1 && this.shareinfo.operations.indexOf('preview')>-1;;
    // },
    showBtn() {
      return this.selectNodes.length > 0;
    },
    operationsStr() {
      if (this.shareinfo.operations && this.shareinfo.operations.length > 0) {
        var text = [];
        if (parseInt(this.shareinfo.expiretype) > 0) {
          text.push(
            this.shareinfo.expiretype + this.$t("pan.text.expire_after_days")
          );
        } else {
          text.push(this.$t("pan.text.permanent_validity"));
        }
        let onlyread = true;
        if (this.shareinfo.operations.indexOf("download") >= 0) {
          text.push(this.$t("pan.text.preview_and_ownload"));
          onlyread = false;
        }
        if (this.shareinfo.operations.indexOf("shareedit") > -1) {
          text.push(this.$t("pan.text.shareedit"));
          onlyread = false;
        }
        if (this.shareinfo.operations.indexOf("onlineedit") > -1) {
          text.push(this.$t("pan.button.onlineEdit"));
          onlyread = false;
        }
        if (this.shareinfo.operations.indexOf("tousers") > -1) {
          text.push(this.$t("pan.text.send_to_colleague"));
          onlyread = false;
        }
        if (this.shareinfo.operations.indexOf("tolinks") > -1) {
          text.push(this.$t("pan.text.external_link"));
          onlyread = false;
        }
        if (this.shareinfo.operations.indexOf("saveas") > -1) {
          text.push(this.$t("pan.text.save_to"));
          onlyread = false;
        }
        if (onlyread) {
          text.push(this.$t("pan.text.preview_only"));
        }
        return text.join(" / ");
      }
      return "";
    },
  },
  methods: {
    onBackToTop:function(){
      document.body.scrollTop =0;
    },
    showUrlPop: function (title, url) {
      this.showUrlBox = true;
      this.urlTitle = title || "";
      this.url = url || "";
    },
    closeUrlPop: function () {
      this.showUrlBox = false;
      this.url = "";
      this.urlTitle = "";
    },
    doRename: function (node, cb) {},
    doDownLoad: function (node, cb) {
      let api = "";
      if(this.sharetype === "link"){
        api = this.openApiUrl
      } else if(this.sahretype === "user"){
        api = this.embedsendApiUrl
      }
      if(!api) return;
      $khttp.post(api,{"op":"askdownload","shareid":this.shareid,"filepath":node.path}).then(function(datas){
        cb && cb(datas);
      }).catch(function(e){
        Toast.fail(e.toString());
      });
    },

    doEdit: function (node, cb,shareable) {
      let _ = this;
      if(this.sharetype == "link"){
        $khttp.post(_.openApiUrl, {
              "op": "askediturl",
              "shareid": this.shareid,
              "username": "",
              "filepath": node.path,
              "policy":JSON.stringify({shareable:shareable})
          }).then(function (url) {
              cb && cb(url);
          }).catch(function (e) {
              Toast.fail(e.data);
          });
      }else if(this.sharetype == "user"){
        $khttp.post(_.embedsendApiUrl, {
            "op": "askediturl",
            "shareid": this.shareid,
            "username": "",
            "filepath": node.path,
            "policy":JSON.stringify({shareable:shareable})
        }).then(function (url) {
            cb && cb(url);
        }).catch(function (e) {
            Toast.fail(e.data);
        });
      }
    },
    returnFromDetail: function () {
      this.showDetail = false;
      this.detailPath = "";
    },
    doDetail: function (node, cb) {
      this.detailPath = node.path;
      this.showDetail = true;
    },
    onRename: function () {
      const node = this.selectNodes[0];
      this.doRename(node, () => {});
    },
    onDownLoad: function () {
      const node = this.selectNodes[0];
      this.showLoader();
      this.doDownLoad(node, (data) => {
        if (data && data.url) {
          window.location = data.url;
        }
        this.hideLoader();
      });
    },
    onDetail: function () {
      const node = this.selectNodes[0];
      this.doDetail(node);
    },
    onEdit: function (shareable) {
      const node = this.selectNodes[0];
      this.showLoader();
      this.doEdit(node, (url) => {
        if (url) {
          this.showUrlPop("编辑", url);
        }
        this.hideLoader();
      }, shareable);
    },
    openUserShare: function () {},
    openLinkShare: function () {},
    onCheckboxClick: function () {
    },
    onRouterClick: function (path, idx) {
      if (this.showPaths.length == 1) return;
      this.doPopShowPath(path.path, idx);
      this.doListDir();
    },
    doPopShowPath: function (path, index) {
      this.currentPath = path;
      if (this.showPaths.length > parseInt(index) + 1) {
        this.showPaths.splice(parseInt(index) + 1);
      }
    },
    doPushShowPath: function (path) {
      this.currentPath = path;
      if (this.showRoot) {
        this.showPaths.push({ path: "", name: "首目录" });
        this.showRoot = false;
      }
      this.showPaths.push({ path: path, name: path.getName() });
    },
    doPreview: function (node, cb) {
      const that = this;
      const filepath = node.path;
      if (this.sharetype == "link") {
        $khttp
          .post("/api/pan/share/open", {
            op: "askviewurl",
            shareid: that.shareid,
            filepath: filepath,
          })
          .then(function (url) {
            cb && cb(url);
          })
          .catch(function (e) {
            console.log(e.toString());
            // Toast.fail(e.toString());
            Toast.fail(that.$t("k.cpt.preview.tips.when.notsupport"));
          });
      } else if (this.sharetype == "user") {
        $khttp
          .post("/api/pan/share/embedsend", {
            op: "askviewurl",
            shareid: this.shareid,
            filepath: filepath,
          })
          .then(function (url) {
            cb && cb(url);
          })
          .catch(function (e) {
            Toast.fail(e.toString());
          });
      }
    },
    onNodeClick: function (idx, node) {
      if (this.showBtn) return;
      if (!node.isfile) {
        this.doPushShowPath(node.path);
        this.doListDir();
        return;
      }
      this.showLoader();
      this.doPreview(node, (url) => {
        if (url) {
          this.showUrlPop("预览", url);
        } else {
          Toast.fail("不支持预览");
        }
        this.hideLoader();
      });
    },
    onLoad: function () {},
    onRefresh: function () {
      this.refreshing = false;
    },
    showLoader: function () {
      Toast.loading({ forbidClick: true, duration: 0 });
    },
    hideLoader: function () {
      Toast.clear();
    },
    // 包裹数据
    buildData: function (datas) {
      if (datas) {
        for (var i = 0; i < datas.length; i++) {
          let filenode = Object.assign({}, datas[i]);
          datas[i] = { node: filenode };
          datas[i].node.cuser = undefined;
          let path = filenode.showpath ? filenode.showpath : filenode.path;
          datas[i].id = $kutil.random() + "_" + i;
          datas[i].isfile = filenode.isfile;
          datas[i].filename = path.getName();
          datas[i].path = filenode.path;
          datas[i].ctime = moment(filenode.ctime, "YYYYMMDDHHmmssSSS").format(
            "YYYY-MM-DD HH:mm"
          );
          if (filenode.isfile) {
            let filever = filenode.versions[filenode.versions.length - 1];
            datas[i].datasize = $kutil.formatSize(filever.datasize);
            datas[i].icon = $kutil.iconUrl2(path);
          } else {
            datas[i].icon = "/kabala/images/mobile/folder.png";
          }
        }
      }
    },
    refreshaccesscount: function (shareid) {
      //刷新访问次数,只要进入到本页就记为访问一次，缓存级别的
      var tempshareid = window.sessionStorage.getItem("kabala.shareid");
      if (!tempshareid || tempshareid == null || tempshareid.length <= 0) {
        $khttp.getSync("/api/pan/share/open", {
          op: "refreshaccesscount",
          shareid: shareid,
        });
        window.sessionStorage.setItem("kabala.shareid", shareid);
      }
    },
    // 取消全选
    onExitMultiSelect: function () {},
    // 加载路径
    doListDir: function () {
      this.showLoader();
      let url = "/api/pan/share/embedsend";
      if (this.shareinfo && this.shareinfo.sharetype == "link") {
        url = "/api/pan/share/open";
      }
      $khttp
        .post(url, {
          op: "listdir",
          shareid: this.shareid,
          dirpath: this.currentPath ? this.currentPath : "",
        })
        .then((nodes) => {
          this.buildData(nodes);
          this.fileList = nodes;
          this.hideLoader();
        })
        .catch((err) => {
          console.log(err);
          Toast.fail({
            message: err.data,
            onClose: function () {
              window.location = "/";
            },
          });
          this.fileList = [];
        });
    },
    doReloadDir: function () {
      this.onExitMultiSelect();
      this.doListDir();
    },
    buildShareData: function (data) {
      if (data) {
        data.ctime_f = $kutil.dateFormat(
          $kutil.formatDateObject(data.ctime),
          "yyyy-MM-dd HH:mm"
        );
        if (data.expiretime == "0" || data.expiretime == 0) {
          data.expiretime_f = "永不过期";
        } else {
          // Invalid date
          data.expiretime_f = $kutil.dateFormat(
            $kutil.formatDateObject(data.expiretime),
            "yyyy-MM-dd HH:mm"
          );
        }
        if (data.operations) {
          // data.operations = data.operations.split(',');
        }
        if (data.uids && data.uids.length > 0) {
          let names = [];
          var len = data.uids.length;
          if(len >= 20){
            len = 20;
          }
          for (var i = 0; i < len; i++) {
            names.push($kuser.getname(data.uids[i]));
          }
          data.names = names.join(",");
        }
      }
    },
    doLoadDetails: function () {
      if (!this.shareid) return;
      this.showLoader();
      $khttp
        .post("/api/pan/share/open", {
          op: "checkaccesscount",
          shareid: this.shareid,
        })
        .then((checkdata) => {
          if (checkdata) {
              var url = ""
              if(this.sharetype == 'link'){
                url = this.openApiUrl // "/api/pan/share/open";
              } else {
                url = this.embedsendApiUrl// "/api/pan/share/embedsend";
              }
              $khttp
                .post( url, {
                  op: "viewshare",
                  shareid: this.shareid,
                })
                .then((data) => {
                  if (data) {
                    this.buildShareData(data);
                    this.shareinfo = data;
                    this.doReloadDir();
                    //刷新访问次数,只要进入到本页就记为访问一次，是缓存级别的
                    this.refreshaccesscount(this.shareid);
                  }
                  Toast.clear();
                })
                .catch((err) => {
                  console.log(err);
                  Toast.fail(err);
                });
          } else {
            Toast.fail("超过最大访问次数");
          }
        })
        .catch((err) => {
          Toast.fail({
            message: err.data,
            onClose: function () {
              window.location = "/";
            },
          });
        });
    },
    doParseShareid: function () {
      this.shareid = $kutil.getQueryParam(window.location.search, "shareid");
      this.sharetype = $kutil.getQueryParam(window.location.search, "type");
    },
  },
  created() {
    // serverInfo.loginoem.largelinklogo logo图片
    try {
      var serverInfo = $khttp.getSync("/kabala/open", { op: "queryserver" });
      this.saasable =  serverInfo.saasable;
      // TODO saas状态切换
      // this.saasable = false;
      if (serverInfo && serverInfo.loginoem) {
          this.$set(this, "serverInfo", Object.assign(this.serverInfo, serverInfo));
          document.title = this.serverInfo.loginoem.title || '开始云盘';
          this.largelinklogo = serverInfo.loginoem.largelinklogo;
      }    
    } catch (e) {
      
    }
    this.doParseShareid();
    this.doLoadDetails();
  },
  mounted(){
    document.body.addEventListener('scroll', ()=>{
        this.showGoToTop = (document.body.scrollTop > 150)
    })
  }

};
</script>

<style scoped>
.backtotop{
  position:fixed; 
  right: 10px; 
  bottom: 90px; 
  width: 35px; 
  height: 35px; 
  border-radius:2px;
   background:rgba(0, 153, 229, .7); 
   color: #fff; 
   display: flex;
  align-items: center;
  justify-content: center;
}
body {
  --ft14: 3.7333333vw;
  --ft16: 4.2666667vw;
  overflow-x: hidden !important;
  overflow-y: auto !important;
}
.ft14 {
  font-size: 3.7333333vw !important;
}
.ft16 {
  font-size: 4.2666667vw !important;
}
.body,
.footer,
.header {
  box-sizing: border-box;
}
.footer{
  margin: 0 10px;
}
.header {
  border-top: 10px solid #f2f2f2;
}
.header,
.body {
  padding: 16px;
}
.header {
  display: flex;
}
.header >>> .kabala-avatar-string {
  position: relative !important;
  left: 0 !important;
  display: block;
  width: 100%;
  height: 100%;
  line-height: 10vw;
  font-size: 6.5233333vw;
}
.kabala-avatar {
  width: 10vw;
  height: 10vw;
  line-height: 10vw;
}
.header .thumb-body {
  /* margin-left: 16px; */
}
.body {
  margin-top: -1.5em;
}
.body div {
  display: flex;
  margin-top: 0.5em;
}
.body div span {
  font-size: 4.266667vw;
}
.body div span:first-child {
  flex-shrink: 0;
}
.body div span + span {
  margin-left: 2em;
}

.footer .fileLen {
  padding-top: 10px;
  padding-left: 16px;
  padding-right: 16px;
  font-size: 3.733333vw;
  line-height: 1;
}
.footer .fileLen.router {
  margin-left: -0.5em;
}
.footer .fileLen.router a {
  margin-left: 0.5em;
}
.footer .fileicon {
  padding-left: 0;
}
.footer .list-item {
  position: relative;
}
.footer .file-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 70px;
  height: 100%;
  padding-right: 16px;
  justify-content: flex-end;
}
.footer .file-btn >>> .van-checkbox__icon {
  font-size: 10px;
}
.footer .file-btn >>> .van-checkbox__icon .van-icon::before {
  display: none;
}

.btngroup >>> .van-grid-item__icon {
  font-size: 5.5vw;
}
.saas-ad-banner img{width: 100%;}
.saas-header{
  padding: 10px 16px;
}
.saas-header img{
  width: 88px;
}

.saas-ad-banner{
    position: relative; bottom: 0; left: 0; right: 0; z-index: 3;
    text-align: center;
}
.saas-ad-banner i{
    display: inline-block;
    position: absolute;
    top: 0px;
    right: 0px;
    /* transform: rotateZ(45deg); */
    font-size: 20px;
    color:#fff;
    cursor: pointer;
    width: 30px;
    height: 30px;
    line-height: 20px;
    /* outline: 1px solid red; */
}
.saas-ad-banner img{
    width: 100%;
    cursor: pointer;
}

#mask{
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    position: fixed;
    background-color: rgba(0,0,0,.3);
    z-index: 4;
}

#Dialog_Main_UserInfo{
    display:none;position:fixed; z-index:999;top:10%;left:50%;transform: translateX(-50%);background-color: #ffffff; width:420px; max-width: 90%;min-height:360px; max-height: 80vh; overflow: auto; border-radius: 3px;box-shadow: 0 0 14px #333;
}
#Dialog_Main_Phone *,
#Dialog_Main_UserInfo *{
    box-sizing: border-box;
}
#Dialog_Main_Phone p,
#Dialog_Main_UserInfo p{
    margin-top: 1em;
    margin-bottom: 1em;
}

#Dialog_Main_UserInfo .btn_close,
#Dialog_Main_Phone .btn_close{
    display: inline-block;
    position: absolute;
    top: 0;
    right: 10px;
    transform: rotateZ(45deg);
    font-size: 20px;
    cursor: pointer;
}
#Dialog_Main_UserInfo .userinfo,
#Dialog_Main_Phone .userinfo{
    padding: 0 20px;
    border-top: 1px solid #ccc;
}
#Dialog_Main_UserInfo .desc,
#Dialog_Main_Phone .desc{
    padding: 0 20px;
}
#Dialog_Main_Phone .desc span{
    color:#469fe3;
}
.btn.blue{
    color:#fff;
    background-color: #469fe3;
}
.btn.grey{
    color:#333;
    background-color: #e9f5ff;
}
#Dialog_Main_UserInfo .btn,
#Dialog_Main_Phone .btn{
    width: 100%;
    line-height: 40px;
    text-align: center;
    border-radius: 3px;
    cursor: pointer;
}
#rescode{
    float: left;
}
#btn_sendphone{
    float: right;
    width: 100px !important;
    height: 40px;
    border: none;
}
#btn_sendphone.disable{
    color:#dddddd;
    background-color: #e9f5ff;
}
@media screen and (max-width: 768px){
    #rescode{
        width: 60% !important;
    }
    .saas-ad-banner{
        margin-top: 14px;
        position: relative;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 3;
        text-align: center;
    }
    .saas-ad-banner img{
        max-width: 100%;
    }
}

.saas-bottom{
  position: fixed;
  bottom: 5px;
  right: 5px;
  z-index: 9999;
}
.saas-bottom .pabs{
  position: absolute;
}
.saas-bottom .saas-ad-bg{
  width: 120px;
}
.saas-bottom .saas-ad-qrcode{
  bottom: 25px;
  right: 16px;
  width: 80px;
  pointer-events: unset !important;
  user-select:unset !important;
}
.saas-bottom .saas-btn-close{
  display: block;
  width: 30px;
  height: 30px;
  top: 0;
  right: 0;
  /* outline: 1px solid red; */
}
.saas-bottom .saas-btn-home{
  display: block;
  width: 180px;
  height: 20px;
  top: 75px;
  left: 0;
  /* outline: 1px solid red; */
}
.saas-bottom .saas-btn-resource{
  display: block;
  width: 180px;
  height: 20px;
  top: 110px;
  left: 0;
  /* outline: 1px solid red; */
}
.file-list-box{
  height:calc(100vh - 300px);
  overflow-x: hidden;
  overflow-y: auto;
}


</style>
